import apiClient from '../../../api/client';
import type {
  CatalogCategoryResponse,
  CatalogoResponse,
  CreateCatalogCategoryDto,
  CreateCatalogoDto,
  Paginated,
  QueryCatalogosDto,
  UpdateCatalogCategoryDto,
  UpdateCatalogoDto,
} from '@aid/shared';

export type {
  CatalogCategoryResponse,
  CatalogoResponse,
  CreateCatalogCategoryDto,
  CreateCatalogoDto,
  QueryCatalogosDto,
  UpdateCatalogCategoryDto,
  UpdateCatalogoDto,
};

export async function getCatalogos(
  params: QueryCatalogosDto,
): Promise<Paginated<CatalogoResponse>> {
  const { data } = await apiClient.get<Paginated<CatalogoResponse>>('/admin/catalogos', { params });
  return data;
}

export async function getCatalogo(id: number): Promise<CatalogoResponse> {
  const { data } = await apiClient.get<CatalogoResponse>(`/admin/catalogos/${id}`);
  return data;
}

export async function createCatalogo(dto: CreateCatalogoDto): Promise<CatalogoResponse> {
  const { data } = await apiClient.post<CatalogoResponse>('/admin/catalogos', dto);
  return data;
}

export async function updateCatalogo(
  id: number,
  dto: UpdateCatalogoDto,
): Promise<CatalogoResponse> {
  const { data } = await apiClient.patch<CatalogoResponse>(`/admin/catalogos/${id}`, dto);
  return data;
}

export async function deleteCatalogo(id: number): Promise<void> {
  await apiClient.delete(`/admin/catalogos/${id}`);
}

export async function getCategorias(): Promise<CatalogCategoryResponse[]> {
  const { data } = await apiClient.get<CatalogCategoryResponse[]>('/admin/catalogos/categories');
  return data;
}

export async function getCategoria(code: string): Promise<CatalogCategoryResponse> {
  const { data } = await apiClient.get<CatalogCategoryResponse>(
    `/admin/catalogos/categories/${encodeURIComponent(code)}`,
  );
  return data;
}

export async function createCategoria(
  dto: CreateCatalogCategoryDto,
): Promise<CatalogCategoryResponse> {
  const { data } = await apiClient.post<CatalogCategoryResponse>(
    '/admin/catalogos/categories',
    dto,
  );
  return data;
}

export async function updateCategoria(
  code: string,
  dto: UpdateCatalogCategoryDto,
): Promise<CatalogCategoryResponse> {
  const { data } = await apiClient.patch<CatalogCategoryResponse>(
    `/admin/catalogos/categories/${encodeURIComponent(code)}`,
    dto,
  );
  return data;
}

export async function deleteCategoria(code: string): Promise<void> {
  await apiClient.delete(`/admin/catalogos/categories/${encodeURIComponent(code)}`);
}
